{
  "version": 1,
  "asset_id": "04a910d6-b30f-44f6-aa7f-d426b0137beb",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/04a910d6-b30f-44f6-aa7f-d426b0137beb/prosper-qr-code.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/04a910d6-b30f-44f6-aa7f-d426b0137beb/prosper-qr-code.png",
  "original_filename": "prosper-qr-code.png",
  "size": 125144,
  "content_type": "image/png",
  "created_at": "2026-07-18T14:25:14Z"
}
